import { createRouter, createWebHistory } from "vue-router";
import Index from "@/views/Index";
import AboutUs from "@/views/AboutUs";
import AllEstate from "@/views/AllEstate";
import Login from "@/views/Login";
import AdvertisingEstate from "@/views/AdvertisingEstate";
import RealEstate from "@/views/RealEstate";
import Error from "@/views/Error";
import store from "@/store";
import DetailsEstate from "@/views/DetailsEstate"

const routes = [
  // {
  //   path: "/",
  //   name: "index",
  //   component: Index,
  // },
  // {
  //   path: "/aboutus",
  //   name: "aboutus",
  //   component: AboutUs,
  //   meta: { loginrequired: true }
  // },
  // {
  //   path: "/allestate",
  //   name: "allestate",
  //   component: AllEstate,
  //   meta: {
  //     loginrequired: true
  //   }
  // },
  // {
  //   path: "/login",
  //   name: "login",
  //   component: Login,
  //   meta: { loginredirect: true }
  // },
  // {
  //   path: "/advertising",
  //   name: "advertising",
  //   component: AdvertisingEstate,
  //   meta: {
  //     loginrequired: true
  //   }
  // },
  // {
  //   path: "/realEstate",
  //   name: "realEstate",
  //   component: RealEstate,
  //   meta: {
  //     loginrequired: true
  //   }
  // },
  {
    path: "/:id",
    name: "details",
    component: DetailsEstate,
    meta: {
      loginrequired: true
    }
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   name: 'not-found',
  //   component: Error
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

// router.beforeResolve(async to => {
//   if (to.meta) {
//     if (to.meta.requiresAuthenticate) {
//       let isAuthenticated = window.localStorage.getItem('isAuthenticated')
//       if (!isAuthenticated)
//         return false
//       else
//         return true
//     }
//   } else {
//     return true
//   }

// })

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.loginrequired)) {
//     if (store.state.isAuthenticated) {
//       next()
//     } else {
//       next("/login")
//     }
//   }
//   else if (to.matched.some(record => record.meta.loginredirect)) {
//     if (!store.state.isAuthenticated) {
//       next()
//     } else {
//       next("/aboutus")
//     }
//   }
//   else if (store.state.isAuthenticated && to.name == 'login') {
//     next(-1)
//   }
//   else {
//     next()
//   }
// })

export default router;